import {
  GetBigNumberDocument,
  GetBigNumberQuery,
  GetBigNumberQueryVariables,
  Scalars,
} from 'generated/graphql';
import { client } from './client';
import { getLocalesForGraphQL } from '../utils/helpers';

export async function getBigNumber(id: string, locale: string) {
  return client.query<GetBigNumberQuery, GetBigNumberQueryVariables>({
    query: GetBigNumberDocument,
    variables: {
      locales: getLocalesForGraphQL(locale),
      where: {
        id,
      },
    },
  });
}
